// extracted by mini-css-extract-plugin
export default {"container":"gH-z","modal":"hH-z","dimensions":"iH-z","brandName":"jH-z","productName":"kH-z","recipientEmail":"lH-z","recommendedFit":"mH-z","hiddenField":"nH-z"};